// @flow
/* eslint-disable ta-code-conventions/has-matching-storydoc */
/* eslint-disable ta-code-conventions/has-matching-test */
/* eslint-disable ta-code-conventions/require-jsdoc */

import React, { type Node, useCallback, memo } from 'react';
import classNames from '@ta/common.classnames';
import { Icon } from '@ta/styleguide.icon';
import styles from './TextInput.css';

type Props = {|
  type: 'OUTLINED' | 'UNDERLINED',
  label: Node,
  iconName?: string,
  placeholder?: ?string,
  maxLength?: ?number,
  value: string,
  onChange: string => mixed,
  onClick?: () => mixed,
|};

/**
 * A styled text input
 */
const TextInput = ({
  type,
  label,
  iconName,
  placeholder,
  maxLength,
  value,
  onChange,
  onClick,
}: Props) => {
  const change = useCallback(
    (evt: SyntheticEvent<HTMLInputElement>) => onChange(evt.currentTarget.value),
    [onChange],
  );

  return (
    <label
      className={classNames(styles.container, {
        [styles.outlined]: type === 'OUTLINED',
        [styles.underlined]: type === 'UNDERLINED',
      })}
    >
      {iconName != null && <Icon className={styles.icon} name={iconName} />}

      <input
        type="text"
        className={classNames(styles.input, { [styles.notEmpty]: value !== '' })}
        value={value}
        placeholder={placeholder}
        maxLength={maxLength}
        onChange={change}
        onClick={onClick}
      />

      <div className={styles.label}>{label}</div>
    </label>
  );
};

export default memo<Props>(TextInput);
